(function() {
  const canvas = document.getElementById('lc-sys-canvas');
  if (!canvas) return;
  const ctx = canvas.getContext('2d');

  function resize() {
    canvas.width  = canvas.offsetWidth;
    canvas.height = canvas.offsetHeight;
  }
  resize();
  window.addEventListener('resize', resize);

  const GOLD = 'rgba(183,148,84,';
  let t = 0;

  function draw() {
    const W = canvas.width, H = canvas.height;
    ctx.clearRect(0, 0, W, H);

    // 4 helix columns on desktop, 2 on mobile
    const cols = W > 640
      ? [0.15, 0.38, 0.62, 0.85]
      : [0.25, 0.75];

    cols.forEach((xR, ci) => {
      const cx   = W * xR;
      const amp  = W * (W > 640 ? 0.04 : 0.06);
      const freq = 0.025;
      const off  = ci * 1.1;

      // Strand dots
      for (let i = 0; i <= 150; i++) {
        const y     = (i / 150) * H;
        const phase = y * freq - t + off;
        const x1    = cx + Math.sin(phase) * amp;
        const x2    = cx + Math.sin(phase + Math.PI) * amp;
        const d1    = (Math.sin(phase) + 1) / 2;

        ctx.beginPath();
        ctx.arc(x1, y, 0.9, 0, Math.PI * 2);
        ctx.fillStyle = GOLD + (0.08 + d1 * 0.18) + ')';
        ctx.fill();

        ctx.beginPath();
        ctx.arc(x2, y, 0.9, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(255,255,255,0.04)';
        ctx.fill();
      }

      // Base-pair rungs
      const rungs = 12;
      for (let r = 0; r < rungs; r++) {
        const y     = (r / rungs) * H + (H / rungs) * 0.5;
        const phase = y * freq - t + off;
        const x1    = cx + Math.sin(phase) * amp;
        const x2    = cx + Math.sin(phase + Math.PI) * amp;
        const alpha = Math.abs(Math.sin(phase)) * 0.1;
        if (alpha < 0.005) continue;

        ctx.beginPath();
        ctx.moveTo(x1, y);
        ctx.lineTo(x2, y);
        ctx.strokeStyle = GOLD + alpha + ')';
        ctx.lineWidth = 0.5;
        ctx.stroke();
      }
    });

    t += 0.002;
    requestAnimationFrame(draw);
  }

  draw();
})();